import React, { ReactNode } from 'react';
import { SText } from 'src/components/SText';
type label = {
  label: string;
  translatingOptions?: Record<string, unknown> | undefined;
};
export type PTrackingColiHistoryTemplatePops = {
  testID?: string;
  icon: ReactNode;
  leftTitle?: label;
  leftSubTitle?: label;
  status: label;
  subStatus?: label;
  style?: React.CSSProperties | undefined;
  leftSubNode?: ReactNode;
  regularStatus?: boolean;
  topTail?: boolean;
  bottomTail?: boolean;
  disabled?: boolean;
  mainRightTextStyle?: any;
};

export const TrackingColiHistoryTemplate: React.FC<PTrackingColiHistoryTemplatePops> = ({
  leftTitle,
  icon,
  status,
  style,
  subStatus,
  leftSubNode,
  regularStatus,
  disabled,
  topTail,
  bottomTail,
  leftSubTitle,
  mainRightTextStyle,
  testID = 'TrackingColiHistoryTemplate',
}) => {
  const disabledClasses = disabled ? 'opacity-50' : '';

  return (
    <div className={` my-4 flex flex-row justify-around  relative items-center ${disabledClasses}`} style={style}>
      {topTail && <div className="absolute -top-3 bg-dark h-4" style={{ width: 0.5 }}></div>}
      <div className="" style={{ width: '30%' }}>
        {!!leftTitle && (
          <SText translatingOptions={leftTitle.translatingOptions} label={leftTitle.label} classNames="text-primary" />
        )}
        {!!leftSubTitle && (
          <SText
            translatingOptions={leftSubTitle.translatingOptions}
            label={leftSubTitle.label}
            classNames="text-gray-400 block"
          />
        )}
      </div>
      <div className="h-10 w-10 rounded-full bg-dark flex items-center justify-center">{icon}</div>
      <div className="flex flex-col" style={{ width: '30%' }}>
        <SText
          translatingOptions={status.translatingOptions}
          label={status.label}
          classNames="block font-semibold text-primary"
          style={mainRightTextStyle}
        >
          {leftSubNode}
        </SText>
        {!!subStatus && (
          <SText translatingOptions={subStatus.translatingOptions} label={subStatus.label} classNames="block" />
        )}
      </div>
      {bottomTail && <div className="absolute -top-3 bg-dark h-4" style={{ width: 0.5 }}></div>}
    </div>
  );
};
